import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccountInfoComponent } from './Components/account-info/account-info.component';
import { ActivitiesListingBodyComponent } from './Components/activities-listing-body/activities-listing-body.component';
import { ActivityDetailsBodyComponent } from './Components/activity-details-body/activity-details-body.component';
import { AdobeRedirectNewComponent } from './Components/adobe-redirect-new/adobe-redirect-new.component';
import { AdobeRedirectComponent } from './Components/adobe-redirect/adobe-redirect.component';
import { ArchivedActivityDetailsBodyComponent } from './Components/archived-activity-details-body/archived-activity-details-body.component';
import { BatchSelectorComponent } from './Components/batch-selector-tool/batch-selector/batch-selector.component';
import { ComponentWithHeaderBatchComponent } from './Components/batch-selector-tool/component-with-header-batch/component-with-header-batch.component';
import { BookmarksComponent } from './Components/bookmarks/bookmarks.component';
import { ComponentWithHeaderComponent } from './Components/component-with-header/component-with-header.component';
import { ExtendCourseSubscriptionComponent } from './Components/extend-course-subscription/extend-course-subscription.component';
import { extendCourseComponent } from './Components/extend-course/extend-course.component';
import { ExtensionTermsComponent } from './Components/extension-terms/extension-terms.component';
import { ForumPostComponent } from './Components/forum-post/forum-post.component';
import { GettingStartedComponent } from './Components/getting-started/getting-started.component';
import { NotesComponent } from './Components/notes/notes.component';
import { PersonalizedStudyPlannerComponent } from './Components/personalized-study-planner/personalized-study-planner.component';
import { PurchasesComponent } from './Components/purchases/purchases.component';
import { RecentActivityBodyComponent } from './Components/recent-activity-body/recent-activity-body.component';
import { RequestOverloadComponent } from './Components/request-overload-page/request-overload-page.component';
import { SidePanelPreviewComponent } from './Components/side-panel-preview/side-panel-preview.component';

const routes: Routes = [
  {
    path: '', component: ComponentWithHeaderComponent,
    children: [
      { path: 'dashboard', component: RecentActivityBodyComponent },
      { path: 'page/:page', component: ActivitiesListingBodyComponent },
      { path: ':view/page/:page', component: ActivitiesListingBodyComponent },
      { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
      { path: 'user' , redirectTo: '/user/account-info', pathMatch: 'full'},
      { path: 'user/account-info/:tab' , component:AccountInfoComponent},
      { path: 'user/purchases' , component:PurchasesComponent},
      // { path: 'user/extensions-old' , component:PurchasesComponent},
      // { path: 'user/extensions' , component:ExtensionTermsComponent},
      { path: 'user/bookmarks' , component:BookmarksComponent},
      { path: 'user/forum-posts' , component:ForumPostComponent},
      { path: 'user/notes' , component:NotesComponent},
      { path: 'adobe-redirect' , component:AdobeRedirectComponent},
      { path: 'adobe-redirect-new' , component:AdobeRedirectNewComponent},
      { path: 'getting-started/:index' , component:GettingStartedComponent},
      { path: 'extend-course-old' , component:extendCourseComponent},
      { path: 'extend-course/:config' , component:ExtendCourseSubscriptionComponent},
    ]
  },
  {
    path: 'live-sessions', component: ComponentWithHeaderBatchComponent,
    children:[
      { path: ':section/batch-selector', component:  BatchSelectorComponent }
    ]
  },

  // Cementing quiz taken inside the course page: the same player (sidebar + iframe) as an activity,
  // but the iframe shows Scholaranium in embedded mode for the given stage.
  { path: "page/:page/cementing/:section/:subject/:difficulty", component: ActivityDetailsBodyComponent },
  { path: ":view/page/:page/cementing/:section/:subject/:difficulty", component: ActivityDetailsBodyComponent },
  // Result / review of a finished cementing quiz, framed the same way.
  { path: "page/:page/cementing-review/:section/:quizId", component: ActivityDetailsBodyComponent },
  { path: ":view/page/:page/cementing-review/:section/:quizId", component: ActivityDetailsBodyComponent },
  { path: "page/:page/activity/:activity", component: ActivityDetailsBodyComponent },
  { path: ":view/page/:page/activity/:activity", component: ActivityDetailsBodyComponent },
  { path: 'archived/page/:page/activity/:activity', component: ArchivedActivityDetailsBodyComponent },
  { path: 'forum/:corelationid', component: ActivityDetailsBodyComponent },
  { path: 'archived/forum/:corelationid', component: ArchivedActivityDetailsBodyComponent },
  { path: 'admin-study-planner' , component:PersonalizedStudyPlannerComponent},
  { path: 'study-planner' , component:PersonalizedStudyPlannerComponent},
  { path: 'your-calendar' , component:PersonalizedStudyPlannerComponent},
  { path: 'your-personalized-view' , component:PersonalizedStudyPlannerComponent},
  { path: 'request-overload-page' , component:RequestOverloadComponent},
  { path: 'side-panel-preview', component: SidePanelPreviewComponent },
  //{ path: 'forgot-password', component: ForgotPasswordComponent },
        //{ path: 'reset-success' , component:ResetSuccessComponent},
  { path: '**', redirectTo: '/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
